import { defineStore } from 'pinia'
import type { AbTestResult } from '@/utils/abtest/abTestV3Types'

const NOT_INITIALIZED_RESULT: AbTestResult<string> = {
  state: 'not-initialized'
}

export const useABTestV3Store = defineStore('ab_test_v3', () => {
  const results = ref<Record<string, AbTestResult<string>>>({})

  function setResult(testName: string, result: AbTestResult<string>): void {
    results.value[testName] = result
  }

  function getResultByName(testName: string) {
    return computed<AbTestResult<string>>(() => {
      return results.value[testName] ?? NOT_INITIALIZED_RESULT
    })
  }

  return {
    results,
    setResult,
    getResultByName
  }
})
